import React from 'react';
import styled from 'styled-components';
import { useSelector, useStore } from 'react-redux';
import { Points } from '@styles';
import { Button } from 'planoplan-ui-kit/core/button';
import { useTranslations } from '@libs/translations';

export const DownloadButton = ({ isDarkMode, isTransparent }) => {
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  return (
    <Wrapper isTransparent={isTransparent}>
      <Button
        theme={isDarkMode ? 'neutral_secondary' : 'secondary'}
        isDarkMode={isDarkMode}
        widthText={true}
        size="S"
        href={`/${locale}/download`}>
        {translations.t('site.navigation.downloadMobileNav')}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.nav`
  display: none;

  @media ${Points.tablet_landscape} {
    display: block;
    width: 120px;
  }

  a {
    background-color: ${(props) => props.isTransparent && 'transparent'};

    &:hover {
      background-color: ${(props) => props.isTransparent && 'transparent'};

      backdrop-filter: blur(5px) saturate(15%);
      -webkit-backdrop-filter: blur(18px) saturate(15%);
    }
  }
`;
